import { ModuleLayout, type ModuleTab } from './ModuleLayout.js';
import { useVisibleTabs } from '../useNavAccess.js';

export const INVENTORY_TABS: readonly ModuleTab[] = [
  { id: 'overview', hrefSuffix: '', label: 'نمای کلی' },
  { id: 'stock', hrefSuffix: '/stock', label: 'موجودی' },
  { id: 'cardex', hrefSuffix: '/cardex', label: 'کاردکس کالا' },
  { id: 'count-sessions', hrefSuffix: '/count-sessions', label: 'انبارگردانی' },
  { id: 'reconciliation', hrefSuffix: '/reconciliation', label: 'مغایرت‌گیری و تطبیق' },
  { id: 'reservations', hrefSuffix: '/reservations', label: 'رزروها' },
  { id: 'receipts', hrefSuffix: '/receipts', label: 'رسیدها' },
  { id: 'issues', hrefSuffix: '/issues', label: 'خروج‌ها' },
  { id: 'transfers', hrefSuffix: '/transfers', label: 'انتقال‌ها' },
  { id: 'adjustments', hrefSuffix: '/adjustments', label: 'تعدیلات' },
  { id: 'tracking-profiles', hrefSuffix: '/tracking-profiles', label: 'قرارداد ردیابی' },
  { id: 'lots', hrefSuffix: '/lots', label: 'بهر و بچ' },
  { id: 'serials', hrefSuffix: '/serials', label: 'سریال‌ها' },
  { id: 'uom-conversions', hrefSuffix: '/uom-conversions', label: 'تبدیل واحدها' },
  { id: 'reports', hrefSuffix: '/reports', label: 'گزارش‌ها' },
  { id: 'assistant', hrefSuffix: '/assistant', label: 'دستیار' },
];

export function InventoryModuleLayout() {
  const tabs = useVisibleTabs('inventory', INVENTORY_TABS);
  return (
    <ModuleLayout
      moduleId="inventory"
      title="انبار"
      subtitle="قابل استفاده = موجودی واقعی − رزرو شده − مسدود"
      tabs={tabs}
      cta={{
        label: 'رسید جدید',
        icon: 'plus',
        hrefSuffix: '/receipts',
        tabIds: ['overview', 'stock'],
      }}
    />
  );
}
